import React, { useEffect, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { getStellaAnalyses } from '../../services/kollectaApi';
import styles from './style.module.css';

const TABS = [
  { key: 'quality_analysis', label: 'Atendimento da IA' },
  { key: 'payment_likelihood', label: 'Propensão de pagamento' },
];

const ScoreBar = ({ score }) => (
  <div className={styles.scoreBarContainer}>
    <div className={styles.scoreBarWrapper}>
      <div className={styles.scoreMarker} style={{ left: `${score}%` }} />
      <div className={styles.scoreBar} />
    </div>
    <div className={styles.scoreBarLabels}>
      <span>qualidade ruim</span>
      <span>qualidade média</span>
      <span>qualidade boa</span>
    </div>
  </div>
);

const formatExcerpt = (text) => {
  if (!text) return '-';
  return text.split('\n').map((line, i) => {
    const clientMatch = line.match(/^(Cliente:)\s*(.*)/);
    const botMatch = line.match(/^(Robô:)\s*(.*)/);
    if (clientMatch) {
      return <div key={i}><strong>Cliente:</strong> {clientMatch[2]}</div>;
    }
    if (botMatch) {
      return <div key={i}><strong>Robô:</strong> {botMatch[2]}</div>;
    }
    return <div key={i}>{line}</div>;
  });
};

const AnalysisDetail = ({ data }) => {
  if (!data) return null;

  const displayScore = data.promptId === 'quality_analysis'
    ? Math.round(data.score / 10)
    : data.score;

  return (
    <>
      <ScoreBar score={data.score} />
      <div className={styles.detailsTable}>
        <div className={styles.detailsRow}>
          <div className={styles.detailsLabel}>Nota da mensagem</div>
          <div className={styles.detailsValue}>
            <span className={styles.scoreValue}>{displayScore}</span>
          </div>
        </div>
        <div className={styles.detailsRow}>
          <div className={styles.detailsLabel}>Justificativa da nota</div>
          <div className={styles.detailsValue}>{data.analysis || '-'}</div>
        </div>
        <div className={styles.detailsRow}>
          <div className={styles.detailsLabel}>Categoria</div>
          <div className={styles.detailsValue}>{data.category || '-'}</div>
        </div>
        <div className={styles.detailsRow}>
          <div className={styles.detailsLabel}>Trecho da conversa</div>
          <div className={`${styles.detailsValue} ${styles.excerpt}`}>{formatExcerpt(data.conversationExcerpt)}</div>
        </div>
        <div className={styles.detailsRow}>
          <div className={styles.detailsLabel}>Comentários adicionais</div>
          <div className={styles.detailsValue}>{data.additionalComments || '-'}</div>
        </div>
      </div>
    </>
  );
};

const InsightsViaIA = ({ cellphone }) => {
  const [analyses, setAnalyses] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('quality_analysis');

  useEffect(() => {
    if (!cellphone) {
      setLoading(false);
      return;
    }

    const formattedCellphone = cellphone.startsWith('55') ? cellphone : `55${cellphone}`;

    getStellaAnalyses(formattedCellphone)
      .then((res) => {
        const data = res.data?.analyses || [];
        const map = {};
        data.forEach((a) => { map[a.promptId] = a; });
        setAnalyses(map);
      })
      .catch(() => setAnalyses(null))
      .finally(() => setLoading(false));
  }, [cellphone]);

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.empty}>Carregando...</div>
      </div>
    );
  }

  const quality = analyses?.quality_analysis;
  const payment = analyses?.payment_likelihood;
  const hasData = quality || payment;

  const qualityScore = quality ? Math.round(quality.score / 10) : null;
  const paymentScore = payment ? `${payment.score}%` : null;

  const getPaymentScoreColor = (score) => {
    if (score <= 40) return 'var(--new-dashboard-orange)';
    if (score <= 60) return 'var(--new-dashboard-yellow)';
    return 'var(--new-dashboard-green)';
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <h3>Insights via IA</h3>
          <FaInfoCircle className={styles.infoIcon} title="Análises geradas automaticamente pela Stella" />
        </div>
        {hasData && (
          <button
            className={styles.rationalButton}
            onClick={() => setShowModal(true)}
          >
            Entender Racional
          </button>
        )}
      </div>

      {hasData ? (
        <div className={styles.scores}>
          <div className={styles.scoreItem}>
            <div className={styles.scoreLabel}>Avaliação do atendimento</div>
            <div className={styles.scoreValueQuality}>
              {qualityScore !== null ? <>{qualityScore}<span>/10</span></> : '-'}
            </div>
          </div>
          <div className={styles.scoreItem}>
            <div className={styles.scoreLabel}>Propensão de pagamento</div>
            <div
              className={styles.scoreValuePayment}
              style={{ color: payment ? getPaymentScoreColor(payment.score) : undefined }}
            >
              {paymentScore || '-'}
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.empty}>Sem análises disponíveis para este contato</div>
      )}

      {showModal && (
        <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h4>Avaliações</h4>
              <button className={styles.modalClose} onClick={() => setShowModal(false)}>X</button>
            </div>

            <div className={styles.tabs}>
              {TABS.map((tab) => (
                <button
                  key={tab.key}
                  className={`${styles.tab} ${activeTab === tab.key ? styles.tabActive : ''}`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <AnalysisDetail data={analyses?.[activeTab]} />
          </div>
        </div>
      )}
    </div>
  );
};

export default InsightsViaIA;
